// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_itemContainer__hN9\\+v {
  margin-bottom: 1rem; }

.styles_titleless__7qXIy {
  padding-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/mapal/submodules/features/components/FeatureFeed/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,mBAAmB,EAAA;;AAGvB;EACI,iBAAiB,EAAA","sourcesContent":[".itemContainer {\n    margin-bottom: 1rem;\n}\n\n.titleless {\n    padding-top: 1rem;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemContainer": `styles_itemContainer__hN9+v`,
	"titleless": `styles_titleless__7qXIy`
};
export default ___CSS_LOADER_EXPORT___;
